import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';
import { Icon } from 'antd';
import { commonData } from '@bit/ui-common.ui-components/ss-common-data';

const
{ validationRules } = ssFormValidationUtils,
{ INPUT, DATE_PICKER, SELECT, CHECK,  generateExtraMessageWithIcon, generateLabelWithPopover } = ssFormUtils,
{ textData } = commonData,
{
    isRequired,
    isName,
    isNameWithOneCharValidation,
    isPhone,
    extensionValidation,
    isPast,
    isEmail,
    isFaa,
    isFuture,
    isMinBirthDate,
    isMinLength,
    isMinLengthWith5Digits,
    isMaxLength,
    isAlphanumeric
} = validationRules;

export const personalFormConfig = {
    key: 'personal',
    step: 1,
    formItems: {
        firstName: {
            label: 'First/Given Name',
            type: INPUT,
            rules: [ isRequired, isName, isMaxLength(50) ]
        },
        middleName: {
            label: 'Middle Name',
            type: INPUT,
            rules: [ isName, isMaxLength(50) ],
            optional: true
        },
        lastName: {
            label: 'Last Name/Surname',
            type: INPUT,
            rules: [ isRequired, isName, isMaxLength(50) ]
        },
        nameSuffix: {
            label: 'Name Suffix',
            type: SELECT,
            rules: [  ],
            optional: true
        },
        dob: {
            label: 'Date of Birth',
            type: DATE_PICKER,
            rules: [ isRequired, isMinBirthDate ]
        },
        dobType: {
            label: 'Date of Birth Type',
            type: SELECT,
            rules: [ isRequired ]
        },
        phoneNumber: {
            label: 'Phone Number',
            type: INPUT,
            rules: [ isPhone ]
        }
    }
};

export const passportFormConfig = {
    key: 'passport',
    step: 2,
    formItems: {
        passportType: {
            label: 'Passport Type',
            type: SELECT,
            rules: [ isRequired ]
        },
        passportNumber: {
            label: 'Passport Number',
            type: INPUT,
            rules: [ isRequired ]
        },
        issueDate: {
            label: 'Issue Date',
            type: DATE_PICKER,
            rules: [ isRequired, isPast ]
        },
        expirationDate: {
            label: 'Expiration Date',
            type: DATE_PICKER,
            rules: [ isRequired, isFuture ]
        },
        issuingCountry: {
            label: 'Issuing Country',
            type: SELECT,
            rules: [ isRequired ]
        },
        city: {
            label: 'City',
            type: INPUT,
            rules: [ isRequired ]
        }

    }
};

export const emailIdConfig = {
    key: 'email',
    step: 3,
    formItems: {
        userId: {
            label: 'User ID',
            type: INPUT,
            rules: [ isRequired, isAlphanumeric ]
        },
        emailAddress: {
            label: 'Email Address',
            type: INPUT,
            rules: [ isRequired, isEmail ]
        },
        verifyEmailAddress: {
            label: 'Verify Email Address',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
};

export const securityConfig = {
    key: 'security',
    step: 4,
    formItems: {
        q1: {
            label: 'What city were you born in',
            type: INPUT,
            rules: [ isRequired ]
        },
        q2: {
            label: 'What is your favorite food?',
            type: INPUT,
            rules: [ isRequired ]
        },
        q3: {
            label: 'What your favorite color?',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
};

export const signatureConfig = {
    key: 'signature',
    step: 5,
    formItems: {
        agree: {
            label: 'I understand and agree to the above',
            type: CHECK,
            rules: [ isRequired ]
        },
        fullName: {
            label: 'Enter full name to digitally sign',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
};

export const providerRegConfig = {
    key: 'provider',
    formItems: {
        firstName: {
            label: 'First/Given Name',
            type: INPUT,
            rules: [ isRequired, isName ]
        },
        middleName: {
            label: 'Middle Name',
            type: INPUT,
            rules: [ isName ],
            optional: true
        },
        lastName: {
            label: 'Last Name/Surname',
            type: INPUT,
            rules: [ isRequired, isName ]
        },
        phoneNumber: {
            label: 'Phone Number',
            type: INPUT,
            rules: [ isPhone ]
        },
        emailAddress: {
            label: 'Email Address',
            type: INPUT,
            rules: [ isRequired, isEmail ]
        },
        verifyEmail: {
            label: 'Verify Email Address',
            type: INPUT,
            rules: [ isRequired, isEmail ]
        },
        schoolName: {
            label: 'Flight Training Provider (School) Name',
            type: INPUT,
            rules: [ isRequired ],
            extra: generateExtraMessageWithIcon('This name will be presented to prospective clients for your business.')
        },
        schoolState: {
            label: 'Flight Training Provider State',
            type: SELECT,
            rules: [ isRequired ],
            extra:  generateExtraMessageWithIcon('Base U.S. state where your business or school is located.')
        },
        schoolType: {
            label: 'Flight Training Provider Type',
            type: SELECT,
            rules: [ isRequired ]
        },
        faaCert: {
            label: 'FAA Certification or Satellite Designator',
            type: INPUT,
            rules: [ isRequired ]
        },
        fsdo: {
            label: generateLabelWithPopover('FSDO, CMO, or IFO', 'FAA Flight Standards District Office (FSDO), Certificate Management Office (CMO), or International Field Office (IFO) who can confirm your certificate.'),
            type: SELECT,
            rules: [ isRequired ]
        },
        agree: {
            label: 'I understand and agree to',
            type: CHECK,
            rules: [ isRequired ]
        }
    }
};

export const fsdoRegConfig = {
    key: 'fsdo',
    formItems: {
        firstName: {
            label: 'First Name',
            type: INPUT,
            placeholder: 'First Name...',
            rules: [ isRequired, isNameWithOneCharValidation, isMaxLength(50) ]
        },
        middleName: {
            label: 'Middle Name',
            type: INPUT,
            placeholder: 'Middle Name...',
            rules: [ isNameWithOneCharValidation, isMaxLength(50) ],
            optional: true
        },
        lastName: {
            label: 'Last Name/Surname',
            type: INPUT,
            placeholder: 'Last Name/Surname...',
            rules: [ isRequired, isNameWithOneCharValidation, isMaxLength(50) ]
        },
        phoneNumber: {
            label: 'Phone Number',
            type: INPUT,
            placeholder: 'Phone number...',
            rules: [ isPhone, isMinLengthWith5Digits(5), extensionValidation, isMaxLength(25) ]
        },
        emailAddress: {
            label: 'Email Address',
            type: INPUT,
            placeholder: 'Email...',
            rules: [ isRequired, isEmail, isFaa, isMaxLength(50) ]
        },
        verifyEmail: {
            label: 'Verify Email Address',
            type: INPUT,
            placeholder: 'Email...',
            rules: [ isRequired, isEmail, isMaxLength(50) ]
        },
        fsdo: {
            label: 'FSDO:',
            type: SELECT,
            placeholder: 'FSDO...',
            rules: [ isRequired ]
        },
        fsdoState: {
            label: 'FSDO State',
            type: SELECT,
            placeholder: 'FSDO State...',
            rules: [ isRequired ]
        }
    }
};
